import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e44cfbf")

_pushScopeId("data-v-4e44cfbf")
const _hoisted_1 = { style: {"color":"#FF7209"} }
const _hoisted_2 = { class: "popover-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_device_icon = _resolveComponent("device-icon")
  const _component_list = _resolveComponent("list")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.operate==='add'
            ?_ctx.$wordList.AddCamera
            :_ctx.$wordList.EditCamera,
    width: "35%",
    onClose: _ctx.close,
    onSubmit: _ctx.submit
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPersonDeviceInHtmlLocation,
            prop: "Location"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Location,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Location = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.RtspAddress,
            prop: "RtspAddress"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.RtspAddress,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.RtspAddress = $event))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_1, _toDisplayString(_ctx.$wordList.RtspFormat), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.UserName,
            prop: "RtspUserName"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.RtspUserName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.RtspUserName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.TabelPersonUserInHtmlPassword,
            prop: "RtspPwd"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                type: "password",
                "show-password": "",
                modelValue: _ctx.formData.RtspPwd,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.RtspPwd = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, { prop: "IsLinkDevice" }, {
            default: _withId(() => [
              _createVNode(_component_el_checkbox, {
                label: _ctx.$wordList.LinkDevice,
                "true-label": 1,
                "false-label": 0,
                modelValue: _ctx.formData.IsLinkDevice,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.IsLinkDevice = $event))
              }, null, 8, ["label", "modelValue"]),
              _createVNode(_component_question_tip, {
                placement: "top-start",
                class: "margin-left10px",
                "self-class": 'question-height18px'
              }, {
                default: _withId(() => [
                  _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$wordList.LinkDeviceTypeTip), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.formData.IsLinkDevice)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                prop: "MAC"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio_group, {
                    class: "width100per",
                    modelValue: _ctx.formData.MAC,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.MAC = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_list, {
                        headers: _ctx.column,
                        "list-data": _ctx.tableData,
                        "show-check": false,
                        action: false,
                        update: _ctx.updateData,
                        class: "max-height600px overflow-auto"
                      }, {
                        RadioSlot: _withId((data) => [
                          _createVNode(_component_el_radio, {
                            label: data.scope.MAC,
                            disabled: _ctx.IsLinkedMAC.includes(data.scope.MAC) && data.scope.MAC!==_ctx.initMAC
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "disabled"])
                        ]),
                        DeviceTypeSlot: _withId((data) => [
                          _createVNode(_component_device_icon, {
                            class: "vertical-align-middle",
                            type: Number(data.scope.DeviceType)
                          }, null, 8, ["type"])
                        ]),
                        _: 1
                      }, 8, ["headers", "list-data", "update"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "onClose", "onSubmit"]))
})